module.exports = __webpack_public_path__ + "img/门诊案件调解-调解信息@2x.d458c967.png";